var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    autoHide: false,
    trigger: 'click hover',
    content: ("" + (_vm.$t('label.share_discount'))),
  }),expression:"{\n    autoHide: false,\n    trigger: 'click hover',\n    content: `${$t('label.share_discount')}`,\n  }"}],attrs:{"href":"#","data-test":"copy"},on:{"click":function($event){$event.stopPropagation();return _vm.copyCode.apply(null, arguments)}}},[_c('Icon',{attrs:{"icon":"link","size":11,"color":"#292929"}}),_c('input',{ref:"link",attrs:{"type":"hidden"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }